import { render, staticRenderFns } from "./EachDistrictConstructionWelfareCentreNumber.vue?vue&type=template&id=6b64d090&scoped=true&"
import script from "./EachDistrictConstructionWelfareCentreNumber.vue?vue&type=script&lang=js&"
export * from "./EachDistrictConstructionWelfareCentreNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b64d090",
  null
  
)

export default component.exports